import { render, staticRenderFns } from "./welfare.vue?vue&type=template&id=15fb1908&scoped=true&"
import script from "./welfare.vue?vue&type=script&lang=js&"
export * from "./welfare.vue?vue&type=script&lang=js&"
import style0 from "./welfare.vue?vue&type=style&index=0&id=15fb1908&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fb1908",
  null
  
)

component.options.__file = "welfare.vue"
export default component.exports